import { TEXT } from 'constants/widgetTypes';
import _ from 'lodash';
import { Frame } from "scenejs";

const { getWidgetBoundingRectForBreakpoint, getWidgetElementForBreakpoint } = require("./layoutManager");

export const calculateRequestForBreakpoint = (editorSession, widgets, breakpoint, liveElementEditor, containerId) => {
  var left = Number.MAX_SAFE_INTEGER;
  var top = Number.MAX_SAFE_INTEGER;
  var bottom = 0;
  var right = 0;

  if(_.size(widgets) === 0){
    return {
      x: 0,
      y: 0,
      width: 50,
      height: 50,
      widgets: widgets
    }
  }

  const widgetUIDs = widgets.map(w => w.uid);
  widgets.forEach(widget => {
    const wRect = getWidgetBoundingRectForBreakpoint(editorSession, widget, breakpoint);
   if (wRect && (!widget.parent || !widgetUIDs.includes(widget.parent))) {
      left = Math.min(wRect.x, left);
      top = Math.min(wRect.y, top);

      right = Math.max(right, wRect.x + wRect.width);
      bottom = Math.max(bottom, wRect.y + wRect.height);
    }
  });

  const width = Math.ceil(right - left);
  var height = Math.ceil(bottom - top);

  const updatedWidgets = widgets.map(item => {
    const layout = _.get(item, `properties.${breakpoint}.layout`);
    const frame = new Frame(layout);
    const element = getWidgetElementForBreakpoint(editorSession, item?.uid, breakpoint);
    const elementRect = element?.getBoundingClientRect();
    let rotateAngle = parseFloat(_.get(layout, 'transform.rotate'), 0);
    
    if (!element) return item;

    const style = window.getComputedStyle(element);
    const transform = style.transform;
    let elementHeight = element.clientHeight || element.offsetHeight;
    let elementWidth = rotateAngle > 45 && item.type !== TEXT ? element.clientWidth || element.offsetWidth : elementRect.width;

    if (!layout.width) {
      frame.set('width', 'auto')
    }

    if (!layout.height) {
      frame.set('height', 'auto');
    }

    const rect = getWidgetBoundingRectForBreakpoint(editorSession, item, breakpoint);
    if (rect) {

      const newX = rect.x - left;
      let newY = rect.y - top;

      if (transform !== 'none') {
        const values = transform.split('(')[1].split(')')[0].split(',');
        const a = parseFloat(values[0]);
        const b = parseFloat(values[1]);
        
        const angleRadians = Math.atan2(b, a); 
        rotateAngle = angleRadians * (180 / Math.PI);
        rotateAngle = rotateAngle < 0 ? rotateAngle + 360 : rotateAngle;
      }
 
      const radians = (Math.PI / 180) * rotateAngle;

      const centerX = elementWidth / 2;
      const centerY = elementHeight / 2;
      let translateX = 0;
      let translateY = 0;

      if (rotateAngle && rotateAngle <= 90) {
        translateX = -(centerX - (centerX * Math.cos(radians)) - (centerY * Math.sin(radians)));
        translateY = -(centerY - (centerX * Math.sin(radians)) - (centerY * Math.cos(radians)));
      } else if (rotateAngle && rotateAngle >90 && rotateAngle <=180) {
        translateX = -(centerX + (centerX * Math.cos(radians)) - (centerY * Math.sin(radians)));
        translateY = -(centerY - (centerX * Math.sin(radians)) + (centerY * Math.cos(radians)));
      } else if (rotateAngle && rotateAngle >180 && rotateAngle <=270) {
        translateX = -(centerX + (centerY * Math.sin(radians)) + (centerX * Math.cos(radians)));
        translateY = -(centerY + (centerX * Math.sin(radians)) + (centerY * Math.cos(radians)));
      } else if (rotateAngle && rotateAngle >=270) {
        translateX = -(centerX - (centerX * Math.cos(radians)) + (centerY * Math.sin(radians)));
        translateY = -(centerY + (centerX * Math.sin(radians)) - (centerY * Math.cos(radians)));
      }

      if (liveElementEditor) {
        if (item.parent === containerId) {
          frame.set('transform', `translate(${translateX + newX}px, ${translateY + newY}px)`);
        } else {
          frame.get();
        }
      } else {
        frame.set('transform', `translate(${translateX + newX}px, ${translateY + newY}px)`);
        frame.set('width', `${elementWidth}px`);
      }
      
    }
    
    return {
      ...item,
      properties: {
        ...item.properties,
        [breakpoint]: {
          ...item.properties[breakpoint],
          layout: frame.get()
        }
      }
    }
  });

  return {
    x: left,
    y: top,
    width: width,
    height: height,
    widgets: updatedWidgets
  };
}
